<mat-card class="contact-card">
    <mat-card-header>
        <mat-card-title class="mb-5">Contact Us</mat-card-title>
        <mat-card-subtitle *ngIf="!community?.contact_us_text_rendered" class="mt-5">We would love to hear from you
        </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <div *ngIf="community?.contact_us_text_rendered" [innerHTML]="community.contact_us_text_rendered"
             class="ck-editorControl"></div>
        <form [formGroup]="contactForm" class="mt-15">
            <mat-form-field appearance="outline" class="w-100" color="accent">
                <mat-label>Message</mat-label>
                <textarea formControlName="message" matInput rows="4"></textarea>
                <mat-error *ngIf="contactForm.controls['message'].hasError('required')">
                    This field is required
                </mat-error>
            </mat-form-field>
            <mat-checkbox formControlName="isAnonymous">Anonymous</mat-checkbox>
        </form>
    </mat-card-content>
    <mat-card-actions>
        <div class="d-flex flex-col text-center align-items-center w-100">
            <button (click)="submit()" [disabled]="contactForm.invalid || loading || timer > 0"
                    color="accent" mat-flat-button>
                Submit
                <mat-icon *ngIf="loading">
                    <mat-spinner color="accent"></mat-spinner>
                </mat-icon>
            </button>
            <ng-container *ngIf="timer > 0">
                <br>
                <small>Please wait {{ timer }} seconds before submitting the form again</small>
            </ng-container>
        </div>
    </mat-card-actions>
</mat-card>
